import { ILoggingSettings } from "@multiweb/logging";

/**
 * Rozhraní inicializační zprávy upload workeru.
 */
export interface IWorkerInitializationMessageData {
    readonly loggingSettings: ILoggingSettings;
}

/**
 * Rozhraní dat konfigurující upload upload jednoho souboru
 * @internal
 */
export interface IUploadData {
    id: number;
    url: string;
    eTag: string;
    fileSize: number;
    fullHash?: string;
    fullHashAlg?: string;
}

/**
 * Data se stavem jednoho nahrávaného souboru
 * @internal
 */
export class UploadData implements IUploadData {
    public id!: number;
    public url!: string;
    public eTag!: string;
    public fileSize!: number;
    public canceled: boolean | undefined;
    public lastByteRead: number | undefined;
    public hasher: any | undefined;
    public responsePromise: Promise<string | void> | undefined;
    public fullHash?: string;
    public fullHashAlg?: string;
}
